








































import { Component, Vue, Prop, Provide, Watch, Emit, Mixins } from 'vue-property-decorator'
import QuestionBox from '@/apps/question/components/QuestionBox.vue'
import ScrollToTop from '@/apps/index/mixins/scrollToTop'
import { isObjectValueEqual, getUrlParams } from '@/utils/urlUtils'

import {
  questionList,
  addQuestionToCart,
  removeUestionFromCart,
  updateQuestionCart
} from '@/apps/question/model/api'
@Component({
  components: {
    QuestionBox
  }
})
export default class QuestionList extends Mixins(ScrollToTop) {
  @Prop() public isUnion!: string

  public data: any = []
  public loading = true
  // pagination-data
  public page = 1
  public total = 0
  public sum = 0
  public perPage = 5
  public hasAnalysis = false
  public blackList = ['103']
  public isMouted = true
  // computed
  private get userInfo() {
    return this.$store.state.user_info
  }
  private get subject() {
    return this.$store.state.subject
  }
  private get cartInfo() {
    return this.$store.state.question.cart
  }
  private get platformlogin() {
    return this.$store.state.platformlogin
  }
  private get moduleName() {
    return this.$route.meta.name
  }

  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    if (!val) return
    if (old && val.username === old.username) return

    this.page = 1
    this.loadQuestions(this.page)
  }
  @Watch('cartInfo', { deep: true })
  onCartChange(val, old) {
    if (isObjectValueEqual(val, old)) {
      return
    }
    this.onFlagChange(this.cartInfo, this.data)
  }
  @Watch('platformlogin')
  onPlatformloginChange(val, old) {
    this.isMouted = false
    this.page = 1
    this.loadQuestions(this.page)
  }
  // mounted
  public mounted() {
    this.loadQuestions(this.page)
  }
  public reset() {
    location.href = '/'
  }
  public onSearch() {
    this.page = 1
    this.loadQuestions(this.page)
  }
  public openAnalysis(item) {
    item.showAnalysis = !item.showAnalysis
  }
  public onFlagChange(data, data2) {
    let dataCopy = JSON.parse(JSON.stringify(data2))
    for (let n of dataCopy) {
      if (!data) {
        return
      }
      if (data.question_ids.findIndex((item) => (n as any).id === item) > -1) {
        n.inShoppingCart = true
      } else {
        n.inShoppingCart = false
      }
      if (n.showAnalysis) {
        n.showAnalysis = true
      } else {
        n.showAnalysis = false
      }
      if (n.is_collected) {
        n.is_collected = true
      } else {
        n.is_collected = false
      }
    }
    this.data = dataCopy
  }
  public async loadQuestions(page: number | string, cata?) {
    const ids: any = this.$route.query.ids
    if (!(this.subject && this.subject.value)) return
    let params: any = {
      page,
      question_ids: ids.split(',').map(item => +item),
    }
    try {
      this.loading = true
      let data: any = await questionList(params)
      if (data.success) {
        this.total = data.data.total_count
        this.sum = data.data.page_count * this.perPage
        this.onFlagChange(this.cartInfo, data.data.questions)
      } else {
        this.total = 0
        this.sum = 0
        this.data = []
      }
    } catch (e) {
      this.total = 0
      this.sum = 0
      this.data = []
    } finally {
      this.loading = false
    }
  }
  public onPageChange(val) {
    this.page = val
    this.loadQuestions(val)
  }
  public async cartAdd(id: number | string) {
    let data: any = await addQuestionToCart({
      question_id: id,
      subject_id: this.subject.value
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.data)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public async cartDelete(id: number | string) {
    let data: any = await removeUestionFromCart({
      question_id: id,
      subject_id: this.subject.value
    })
    if (data.success) {
      // 更新购题篮
      this.$store.commit('SET_CART', data.data)
      this.onFlagChange(this.cartInfo, this.data)
    } else {
      this.$message.warning(data.error)
      if (data.error === '请登录') {
        window.location.reload()
      }
    }
  }
  public addToCart(data) {
    if (data.val) {
      this.cartAdd(data.id)
    } else {
      this.cartDelete(data.id)
    }
  }
}
